import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import PageToolbar from './PageToolbar';
import Api from 'src/Api';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#fff',
  },

  meta: {
    color: '#5b5b6b',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
}));

const DashboardHeader = ({ icon, title,subtitle }) => {
  const classes = useStyles();
  const { username, jobTitle } = Api.request;

  const today = new Date().toLocaleDateString('en-PH', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <PageToolbar
      icon={icon}
      title={title}
        subtitle={
        subtitle ||
        (username ? `Signed in as ${username}` : undefined)
      }
      actions={
        <Typography
          variant="body2"
          className={classes.meta}
        >
          {today}
          {jobTitle ? <> &middot; {jobTitle}</> : null}
        </Typography>
      }
    />
  );
};

export default DashboardHeader;